import {useMemo} from "react";
import {useScreenConfig} from "../ScreenConfigContext";
import {ScreenType} from "../../config/ScreenConfig";
import {useSeatConfig} from "../SeatConfigContext";

export const useCenterSpeaker = (config, builtInWall, speakerType) => {
    const {type, screenFloorDistance, acousticTransparent} = useScreenConfig();
    const {primaryEarPosition} = useSeatConfig();
    return useMemo(() => {
        const d = config.size[2] * .5;

        // default center speaker placement
        let y = screenFloorDistance - config.size[1] - 10;
        let z = -d;

        if (builtInWall) {
            if (acousticTransparent)
                y = primaryEarPosition[1] - config.speakerOffset[1];
        } else if (type === ScreenType.UltraShortThrow) {
            // cupboard height
            y = 12;
            z -= 20;
        }

        return {
            position: [0, y, z],
            rotation: Math.PI
        }
    }, [config, screenFloorDistance, builtInWall, type, acousticTransparent, primaryEarPosition]);
}
